import { render, staticRenderFns } from "./TheActivityBox.vue?vue&type=template&id=5fb9696d"
import script from "./TheActivityBox.vue?vue&type=script&lang=js"
export * from "./TheActivityBox.vue?vue&type=script&lang=js"
import style0 from "./TheActivityBox.vue?vue&type=style&index=0&id=5fb9696d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports